import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_unit_measures_by_product: false,
  unit_measures_by_product: [],
  saving_unit_measure_ids: [],
  saved_unit_measure_ids: [],
  removing_unit_measure_ids: []
}

const productUnitMeasuresReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_UNIT_MEASURES_BY_PRODUCT: {
      return {
        ...state,
        loading_unit_measures_by_product: action.payload.loading,
        unit_measures_by_product: action.payload.data ?? state.unit_measures_by_product
      }
    }
    case Actions.SAVE_PRODUCT_UNIT_MEASURE: {
      return {
        ...state,
        saved_unit_measure_ids: toggleIdInArray(state.saved_unit_measure_ids, action.payload.saved_id),
        saving_unit_measure_ids: toggleIdInArray(state.saving_unit_measure_ids, action.payload.saving_id),
        unit_measures_by_product: action.payload.data
          ? addOrUpdateObjectInArray(state.unit_measures_by_product, action.payload.data, 'unidad_medida_id')
            .map(um => {
              if (action.payload.data?.esprincipal === 1) {
                return {
                  ...um,
                  esprincipal: um.unidad_medida_id === action.payload.data?.unidad_medida_id
                    ? 1
                    : 0
                }
              }
              return um
            })
          : state.unit_measures_by_product
      }
    }
    case Actions.REMOVE_PRODUCT_UNIT_MEASURE: {
      return {
        ...state,
        removing_unit_measure_ids: toggleIdInArray(state.removing_unit_measure_ids, action.payload.removing_id),
        unit_measures_by_product: state.unit_measures_by_product.filter(um => um.unidad_medida_id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}
export default productUnitMeasuresReducer
